import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
`;

export const KnowledgeBaseContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
`;

export const KnowledgeBaseItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`;

export const AutocompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div:first-child {
    width: 100%;
    > div:first-child {
      width: 100%;
    }
  }
`;

export const TitleDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const TitleAndListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CollapsibleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const UsersListScrollWrapper = styled.div`
  max-height: 300px;
  position: relative;
`;

export const UsersListContainerExternal = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: visible;
  position: relative;
  
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray || '#f1f1f1'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.lighterGray || '#888'};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.lighterGray || '#555'};
  }

  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.colors.lighterGray || '#888'} ${props => props.theme.colors.highClearGray || '#f1f1f1'};
`;

export const UsersListContainerInternal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 8px 0;
  overflow: visible;
  position: relative;
`;

export const UserItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  transition: background-color 0.2s;
  position: relative;
  z-index: 1;

  &:hover {
    background-color: ${props => props.theme.colors.ghostWhite || '#f5f5f5'};
    z-index: 10;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const UserActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  position: relative;
  z-index: inherit;

  & .list-actions > button { 
    min-width: 120px;
  }
`;

